// @flow

/**
 * Module dependencies.
 */

import { Button } from 'client/components/core/buttons';
import { Col, Container, Row } from 'client/components/core/grid';
import { Link } from 'react-router-dom';
import { Separator } from 'client/components/separator';
import { colors, gradients, media, units } from 'client/styles';
import { getLocalizedUrl } from 'client/core/utils';
import Icon from 'client/components/core/icon';
import Layout from 'client/components/core/layout';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  cta: Object,
  leftItem: Object,
  rightItem: Object
};

/**
 * `globalMoneyStyle` style.
 */

const globalMoneyStyle = 'transform: translateX(4%);';

/**
 * `SeparatorHorizontal` styled component.
 */

const SeparatorHorizontal = styled(Separator.Horizontal)`${media.max.sm`display: none;`}`;

/**
 * `ColFlexCenter` styled component.
 */

const ColFlexCenter = styled(Col)`
  ${media.min.md`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `}
`;

/**
 * `MoneyTrasfer` component.
 */

function MoneyTrasfer(props: Props): React$Element<*> {
  const {
    cta,
    leftItem,
    rightItem
  } = props;

  return (
    <Layout
      backgroundImage={gradients.sand}
      paddingBottom={units(8)}
      paddingBottomSm={units(15)}
      paddingTop={units(8)}
      paddingTopMd={units(2)}
    >
      <Container>
        <Layout
          paddingBottom={units(8)}
          paddingBottomMd={0}
        >
          <Row>
            <Layout
              displaySm={'flex'}
              paddingBottomLg={units(4)}
              paddingTopLg={units(0)}
              paddingVerticalMd={units(8)}
            >
              <ColFlexCenter
                lg={5}
                md={6}
                xs={10}
                xsOffset={1}
              >
                <Layout
                  marginBottom={units(2)}
                  marginBottomMd={units(6)}
                >
                  <Text.H2 color={colors.brandPrimary}>
                    {leftItem.title}
                  </Text.H2>

                  <Layout displayMd={'none'}>
                    <Icon
                      icon={'illustration-global-money'}
                      size={'100%'}
                      styles={globalMoneyStyle}
                    />
                  </Layout>
                </Layout>

                <Row>
                  <Layout position={'relative'}>
                    <SeparatorHorizontal topRight/>

                    <Col
                      sm={10}
                      smOffset={2}
                      xs={12}
                    >
                      <Layout marginBottom={units(3)}>
                        <Text.H4>
                          {leftItem.lead}
                        </Text.H4>
                      </Layout>
                    </Col>
                  </Layout>
                </Row>
              </ColFlexCenter>

              <ColFlexCenter
                lg={6}
                md={5}
                smHidden
                xs={12}
                xsHidden
              >
                <Layout overflow={'hidden'}>
                  <Icon
                    icon={'illustration-global-money'}
                    size={'115%'}
                    styles={globalMoneyStyle}
                  />
                </Layout>
              </ColFlexCenter>
            </Layout>
          </Row>
        </Layout>

        <Row>
          <Layout displaySm={'flex'}>
            <ColFlexCenter
              lg={6}
              md={5}
              smHidden
              xs={12}
              xsHidden
            >
              <Icon
                icon={'illustration-licensed-platform'}
                size={'100%'}
              />
            </ColFlexCenter>

            <ColFlexCenter
              lg={5}
              md={6}
              mdOffset={0}
              xs={10}
              xsOffset={1}
            >
              <Layout
                marginBottom={units(2)}
                marginBottomMd={units(6)}
              >
                <Text.H2 color={colors.brandPrimary}>
                  {rightItem.title}
                </Text.H2>

                <Layout displayMd={'none'}>
                  <Icon
                    icon={'illustration-licensed-platform'}
                    size={'100%'}
                  />
                </Layout>
              </Layout>

              <Row>
                <Layout position={'relative'}>
                  <SeparatorHorizontal topRight/>

                  <Col
                    sm={10}
                    smOffset={2}
                    xs={12}
                  >
                    <Layout marginBottom={units(3)}>
                      <Text.H4>
                        {rightItem.lead}
                      </Text.H4>
                    </Layout>
                  </Col>
                </Layout>
              </Row>
            </ColFlexCenter>
          </Layout>
        </Row>

        <Layout
          paddingTop={units(8)}
          paddingTopSm={units(15)}
          textAlign={'center'}
        >
          <Row>
            <Col
              md={6}
              mdOffset={3}
              sm={8}
              smOffset={2}
              xs={10}
              xsOffset={1}
            >
              <Layout marginBottom={units(2)}>
                <Text.Paragraph color={colors.brandPrimary}>
                  {cta.hint}
                </Text.Paragraph>
              </Layout>

              <Layout marginBottom={units(2)}>
                <Separator.Vertical inline />
              </Layout>

              <Layout marginBottom={units(6)}>
                <Text.H3 color={colors.brandPrimary}>
                  {cta.lead}
                </Text.H3>
              </Layout>

              <Button
                element={Link}
                to={getLocalizedUrl(cta.button.key)}
              >
                {cta.button.label}
              </Button>
            </Col>
          </Row>
        </Layout>
      </Container>
    </Layout>
  );
}

/**
 * Export `MoneyTrasfer` component.
 */

export default MoneyTrasfer;



// WEBPACK FOOTER //
// ../src/client/components/home/money-transfer.js